import { render, staticRenderFns } from "./adjust-credits-modal.vue?vue&type=template&id=99a4cc32&scoped=true&"
import script from "./adjust-credits-modal.ts?vue&type=script&lang=ts&"
export * from "./adjust-credits-modal.ts?vue&type=script&lang=ts&"
import style0 from "./adjust-credits-modal.scss?vue&type=style&index=0&id=99a4cc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a4cc32",
  null
  
)

export default component.exports